/**
 * 서버에서 오는 reply code를 정의한다.
 */
var ReplyCode = {
	"NO_ERROR"           : 0,
	"UNREGISTERED_USER"  : 1,
	"DATA_NOT_FOUND"     : 2, 
	"SYSTEM_ERROR"       : 3,
	"UNDEFINED_CODE"     : 4
};

var ReplyCode_MSG = {
		"KO" : [
			"NO_ERROR",
			"사용자 정보가 없습니다. 로그인 확인해주세요.",
			"해당 정보를 찾을수 없습니다.", 
			"시스템 에러 입니다.",
			"확인되지 않은 코드 입니다." 
		],
		"EN"  : [
			"NO_ERROR"           ,
			"UNREGISTERED_USER"  ,
			"DATA_NOT_FOUND"     , 
			"SYSTEM_ERROR"       ,
			"UNDEFINED_CODE"    
		],

};

var ChatNotice_MSG = {
		"KO" : [
			{"type":"chatBot", "msg":"삼성SDS챗봇"},
			{"type":"loginFirst", "msg":"로그인 후 사용가능합니다."},
			{"type":"tryAgain", "msg":"다시 시도해주세요."},
			{"type":"chatOpened", "msg":"채팅창이 열려 있습니다.\n채팅창을 닫은 후 새로고침 하시기 바랍니다."},
		],
		"EN"  : [
			{"type":"chatBot", "msg":"Samsung SDS ChatBot"},
			{"type":"loginFirst", "msg":"Login First"},
			{"type":"tryAgain", "msg":"Try Again."}, 
			{"type":"chatOpened", "msg":"Chat Opened.\nChat Close and Refresh."},
		],

};


// 서버와 통신하는 enum을 만든다.
// ASK = request, REP = response
var ChatDataType = {
		"UNDEFINED": 0,
		"START": 100,		
		"START_REP": 101,
		"END": 102,
		"END_REP": 103,
		
		"KNOWLEDGE_ASK": 1,
		"KNOWLEDGE_REP": 2,		
		"CHAT_TEXT": 3,
		"CHAT_FILE": 4,
		"SEVER_MESSAGE": 5,
		
		"RECOMMENDHOLD_ASK": 6,
		"RECOMMENDHOLD_REP": 7,
		"KNOWLEDGEFILTER_ASK":8,
		"KNOWLEDGEFILTER_REP": 9,
		
		"PING" : 200,		// 클라이언트가 일정 간격으로 서버로 ping을 보내고
		"PONG" : 201,		// 서버가 ping 응답으로 pong을 보낸다.
};


/**
 * AA Service을 위한 WebSocket 연결 클래스
 */
var ChatSession = function() {
	// 생성자에서 멤버 변수를 초기화한다.
	this.connected = false;
	this.socket = null;

	this.handlerMap = new Map();
	
	this.connectHandler = null,		// websocket 연결되면 처리하는 핸들러
	this.closeHandler = null,		// websocket 연결 끊어지면 처리하는 핸들러
	this.startRepHandler = null,	// START_REP을 받으면 처리하는 핸들러
	this.endRepHandler = null,		// END_REP을 받으면 처리하는 핸들러
	this.knowledgeRepHandler = null, // 지식추천 데이터를 받으면 처리하는 핸들러
	
	this.pingCounter = 0,	// ping 횟수, ping 보낼 때마다 1씩 증가한다. pong을 받으면 0으로 바꾼다.
	this.doPing = true,
	this.pingTimer = -1,
	this.pingInterval = 25 * 1000,	// 밀리초단위. 1 * 60 * 1000 분.  크롬 관련   권고 시간
	this.pingMaxCount = 20; 	// ping 최대 재시도 횟수
	
	this.webChatInfo = "";
	this.webChatLangCd = "";
	this.deviceInfo = "";
	
	this.chatroomId = "";
	this.botCd = "";
//	this.jsessionId = "";
//	this.bsCode = "";
}

ChatSession.prototype.isFunction = function(handler) {
	if(handler === null || typeof handler === 'function') {
		return true;
	}	
	return false;
};

ChatSession.prototype.setConnectHandler = function(handler) {
	if(this.isFunction(handler)) {
		this.connectHandler = handler;
	}
};

ChatSession.prototype.setCloseHandler = function(handler) {
	if(this.isFunction(handler)) {
		this.closeHandler = handler;
	}
};

/**
 * 메시지를 처리할 메시지 핸들러를 설정한다.
 * msgName : xxxRep과 같이 서버에서 온 메시지 이름.
 * handler : 메시지 핸들러 함수
 */
ChatSession.prototype.setHandler = function(msgName, handler) {
	if(msgName !== null && msgName !== undefined && msgName.length > 0 && this.isFunction(handler)) {
		this.handlerMap.set(msgName, handler);
	}
};

/**
 * 서버와 연결한다.
 * 연결된 상태에서 이 함수를 호출하면 이전 연결은 끊기고 새로 연결한다.
 * 왜냐하면 WebSocket을 새로 만들어서 this.socket에 할당하면 이전 값은 없어지고(=연결이 끊기고) 새로 연결된다.
 */
ChatSession.prototype.connect = function(host) {
	if ('WebSocket' in window) {
		this.socket = new WebSocket(host);
	} else if ('MozWebSocket' in window) {
		this.socket = new MozWebSocket(host);
	} else {
		console.debug("Error: WebSocket is not supported by this browser.");
		return -1;
	}
	
	this.socket.owner = this;
	
	this.socket.onopen = function () {
		this.owner.connected = true;
		if(typeof this.owner.connectHandler === 'function') {
			this.owner.connectHandler();
		}

		this.owner.handlerMap.set("Pong", this.owner.onPong);
		this.owner.startPing();	 // 디버그시 주석처리
	};

	this.socket.onclose = function () {
		this.owner.stopPing();
		this.owner.connected = false;
		
		if(typeof this.owner.closeHandler === 'function') {
			this.owner.closeHandler();
		}
	};

	this.socket.onmessage = function (msg) {
	    // console.log('msg >>>>>>', msg);
		const start = Date.now();
		var chatData = JSON.parse(msg.data);		
	    // console.log('chatData >>>>>>', chatData);
		
		// 커스텀 서비스는 별도로 핸들러에 붙인다 
		// @GentlePie KimTaeOh
        var isCustomService = false;
        if(chatData.dataName == "ChatTextRep"){
        	var serverMsg = chatData.serverMsg;

        	if(serverMsg.messages !== undefined && serverMsg.messages.length > 0){
        		if(serverMsg.messages[0].form !== undefined){
                    var formMsg = JSON.parse(serverMsg.messages[0].form);
                    if( formMsg.richForm !== undefined && formMsg.richForm.length > 0 && formMsg.richForm[0].type == 'CUSTOM_SERVICE'){
						gentleApp.customServiceHandler(formMsg.richForm[0]);
						isCustomService = true;
        	        }
        	    }
        	}
        }
        
        // 커스텀 서비스가 아닌경우에만 원래 동작데로 
		// @GentlePie KimTaeOh
        if( isCustomService === false){
			var handler = this.owner.handlerMap.get(chatData.dataName);		

			if(typeof handler === 'function') {
				handler(chatData, this.owner);
			}
		}
		
		const end = Date.now();		
	};
	
	return 0;
};


/**
 * 서버와의 연결을 끊는다.
 */
ChatSession.prototype.disconnect = function() {
	// console.log(">>>>>>>>>> 웹소캣 연결 종료");
	this.socket && this.socket.close();
};

/**
 * chatId, domainCode 정보를 서버로 보낸다.
 */
ChatSession.prototype.start = function() {
	var obj = new Object();
	obj.dataType = ChatDataType.START;
	obj.dataName = "StartRep";
	obj.sessionInfo = this.webChatInfo;
	obj.deviceInfo = this.deviceInfo;
	obj.botCd = this.botCd;
//	obj.jsessionId = this.jsessionId;
//	obj.bsCode = this.bsCode;

	
	this.sendObj(obj);	
	return 0;
};

ChatSession.prototype.end = function() {
	var obj = new Object();
	obj.dataType = ChatDataType.END;
	obj.dataName = "EndRep";

	this.sendObj(obj);	
	return 0;
};

/**
 * 연결된 websocket으로 object를 json으로 바꾸어서 보낸다.
 */
ChatSession.prototype.sendObj = function(obj) {	
	console.log(JSON.stringify(obj))
	if(obj === null || obj === undefined || obj === "") {
		console.debug("object to be sent is " + obj);
		return -1;
	}	
	if(!this.connected) {
		console.debug("not connected. can't send object");
		return -1;
	}
	var jsonStr = JSON.stringify(obj);
	try {
		this.socket.send(jsonStr);
	}
	catch(ex) {
		console.debug(ex);
	}	
		    
	return jsonStr.length;
};

/**
 * 파일을 업로드한다.
 * data는 base64로 인코딩된 파일
 */
ChatSession.prototype.uploadFile = function(filename, data) {
	
	var obj = new Object();
	obj.dataType = ChatDataType.CHAT_FILE; //9-->4
	obj.dataName = "FileUploadAsk";
	obj.sessionInfo = this.webChatInfo;
	obj.file_name = filename;
	obj.file_data = data;
	
	this.sendObj(obj);
		
	return 0;
};



ChatSession.prototype.chatText = function(chatText) {
	console.log('chatText >>>>>>>>', chatText);
	
	if(chatText.length === 0) {
		console.debug("no chatId");
		return -1;
	}

	if(window.chatbotConsulting)   // 상담중이라면
	{            
		// todo: 상담보내기
		if(window.TalkSend){
			window.TalkSend(chatText);
		}
		return 0;
	}

	var obj = new Object();
	obj.dataType = ChatDataType.CHAT_TEXT;
	obj.dataName = "ChatTextRep";
	obj.sessionInfo = this.webChatInfo;
	obj.deviceInfo = this.deviceInfo;
	obj.chatMessage = {};
	obj.chatMessage.messages = [];
	obj.chatMessage.messages.push({"type":"text", "text":chatText, "buttons":[]});
	this.sendObj(obj);	
	
	//메세지 보내고 로딩 박스 
	if (ChatConsole.surveyMode != "S"){
		ChatConsole.loadingBox (false);
		ChatConsole.loadingBox (true);
	}
	
	return 0;
};

ChatSession.prototype.chatObject = function(chatObject) {
	
	var obj = new Object();
	if (chatObject.type == 'file'){
		obj.dataType = ChatDataType.CHAT_FILE;
		obj.dataName = "ChatFileRep";
		obj.sessionInfo = this.webChatInfo;
		obj.deviceInfo = this.deviceInfo;
		obj.chatMessage = {};
		obj.chatMessage.messages = [];
		obj.chatMessage.messages.push({"type":"file", "text":chatObject.text, "buttons":[]});

		console.debug(obj);	
		this.sendObj(obj);	
	}
	else if (chatObject.type == 'text'){
		obj.dataType = ChatDataType.CHAT_TEXT;
		obj.dataName = "ChatTextRep";
		obj.sessionInfo = this.webChatInfo;
		obj.deviceInfo = this.deviceInfo;
		obj.chatMessage = {};
		obj.chatMessage.messages = [];
		obj.chatMessage.messages.push({"type":"text", "text":chatObject.text, "buttons":[]});

		console.debug(obj);	
		this.sendObj(obj);	
		
		//메세지 보내고 로딩 박스 
		if (ChatConsole.surveyMode != "S"){
			ChatConsole.loadingBox (false);
			ChatConsole.loadingBox (true);	
		}
		return 0;
		
	}
};

ChatSession.prototype.severMessage = function() {
	var obj = new Object();
	obj.dataType = ChatDataType.SEVER_MESSAGE;
	//obj.dataName = "ChatTextRep";
	console.debug(obj);	
	this.sendObj(obj);	
	return 0;
};



ChatSession.prototype.knowledgeFilter = function(chatId, domainCode, knowledgeFilters) {
	if(chatId.length === 0) {
		console.debug("no chatId");
		return -1;
	}

	if(domainCode.length === 0) {
		console.debug("no domainCode");
		return -1;
	}
	
	var obj = new Object();
	obj.dataType = ChatDataType.KNOWLEDGEFILTER_ASK;
	obj.chatId = chatId;
	obj.domainCode = domainCode;
	obj.knowledgeFilters = knowledgeFilters;
	
	console.debug(obj);	
	this.sendObj(obj);	
	return 0;
};

ChatSession.prototype.startPing = function() {
	this.doPing = true;	
	if(this.pingTimer !== -1) {
		clearTimeout(this.pingTimer);
	}
	
	var that = this;
	this.pingTimer = setTimeout(function() { that.sendPing(); }, that.pingInterval);
}

ChatSession.prototype.stopPing = function() {
	this.doPing = false;
	if(this.pingTimer !== -1) {
		clearTimeout(this.pingTimer);
		this.pingTimer = -1;
	}
}


ChatSession.prototype.sendPing = function() {

	if(!this.doPing) {	
		return;
	}
	
	this.pingCounter++;
	
	if(this.pingCounter > this.pingMaxCount) {
		this.disconnect();
		console.debug("경고 : 서버 오류가 발생하여 서버 연결을 종료합니다.");
		alert("경고: 서버에서 응답이 없어 연결을 끊었습니다.");
		return;
	}
	
	var obj = new Object();
	obj.dataType = ChatDataType.PING;
	obj.dataName = "Pong";
	obj.sessionInfo = this.webChatInfo;
	obj.deviceInfo = this.deviceInfo;

	this.sendObj(obj);

	var that = this;
	this.pingTimer = setTimeout(function() { that.sendPing(); }, that.pingInterval);
}

/**
 * 서버에서 PONG을 받았다.
 */
ChatSession.prototype.onPong = function(data, that) {
	that.pingCounter = 0;
	if(data.reply === ReplyCode.NO_ERROR) {
		// pong이 왔고 오류가 없는 경우
	}else {
		console.debug(data.reply);
		that.stopPing();
		that.disconnect();
		console.debug("경고 : 서버 오류가 발생하여 서버 연결을 종료합니다.");
		alert("경고 : 서버 오류가 발생하여 서버 연결을 종료합니다.");
	}
} 
